<template>
  <div class="w-100" >
    <!--以下是退款頁面-->
    <div v-if="pageType==='return'">
      <div class="mb-5">
      <h5>{{$t('order.return.returnGoods')}}</h5>
      <OrderDetail class="mx-3" :order="order" :isReturnRequestPage="true">
        <template slot="itemAccount">
          <div></div>
        </template>
      </OrderDetail>
      </div>
      <div class="mb-5">
      <h5 class="mb-3">{{$t('order.return.reasons')}}</h5>
      <b-form-group>
        <h6 class="font-size-md"><span class="ml-n1 text-danger">*</span>{{$t('order.reason')}}</h6>
        <b-select v-model="selected" :options="retunrOptions" :state="validateState" class="bg-white"></b-select>
      </b-form-group>
      <b-form-group>
        <b-textarea class="bg-white"
         :placeholder="$t('order.return.reasonsPlaceholder')"
         :maxlength="limit"
         :state="validateTextArea"
         v-model="reasons"></b-textarea>
        <div id="input-live-feedback" class="invalid-feedback d-flex justify-content-between">
          <span>{{!this.validateTextArea&&this.validateTextArea!=undefined?$t('order.return.textareaWording'):''}}</span>
          <small class="text-gray600">
            <span>{{ reasons.length }}</span>/{{ limit }}
          </small>
        </div>
      </b-form-group>
      </div>
      <!--退件資訊 begin-->
      <div class="mb-5">
      <h5 class="mb-3">{{$t('order.return.recipientInfo')}}</h5>
      <b-form-group>
        <h6 class="font-size-md"><span class="ml-n1 text-danger">*</span>{{$t('personal-info.name')}}</h6>
        <b-input class="bg-white" :placeholder="$t('order.nameplaceholder')" @blur="checkReturnName" v-model="returnName"></b-input>
        <span class="text-danger" v-if="!returnNameCheck.validate && returnNameCheck.validate!=undefined">{{returnNameCheck.warning}}</span>
      </b-form-group>
     <Mobile
        :required="true"
        :editable="true"
        :answer="mobileData"
        @updateData="updateData('mobile',$event)"
        ref="mobile"
        @validateDone="validateAgain"
      />
      <Address :required="true" :editable="true" :id="'Address'" :answer="returnAddress" ref="Address"  @updateData="updateData('address',$event)">
        <template slot="title">
           <h6 class="font-size-md" slot="title"><span class="text-danger ml-n1">*</span>{{ $t('personal-info.address') }}</h6>
        </template>
        <template slot="country">
          <div></div>
        </template>
        <template slot="address">
          <b-form-input
            v-model="returnAddress.address"
            @blur="validateAddress"
            class="bg-white mt-3"
            :placeholder="$t('personal-info.address')"
            type="text"
            :state="validateAddressState"
            maxlength="100"
          ></b-form-input>
          <b-form-invalid-feedback :state="validateAddressState">{{ validateAddressStatewarning }}</b-form-invalid-feedback>
        </template>
      </Address>
      </div>
      <!--退件資訊 end-->
      <!-- 退款帳戶 begin -->
      <div class="mb-5" v-if="this.order.paymentType.includes('COD')&&this.order.paymentType">
      <h5 class="mb-3">{{$t('order.return.returnaccount')}}</h5>
      <b-form-group>
        <h6 class="font-size-md"><span class="ml-n1 text-danger">*</span>{{$t('order.return.account.accountname')}}</h6>
        <b-input class="bg-white" :placeholder="$t('order.accountNameplaceholder')" v-model="returnAccount.accountName.value"></b-input>
        <span class="text-danger" v-if="!returnAccount.accountName.validate && returnAccount.accountName.validate!=undefined">{{returnAccount.accountName.warning}}</span>
      </b-form-group>
      <b-form-group>
        <h6 class="font-size-md"><span class="ml-n1 text-danger">*</span>{{$t('order.return.account.accountbank')}}</h6>
        <b-input class="bg-white" :placeholder="$t('order.bankplaceholder')" v-model="returnAccount.bank.value" :formatter="inputFormatter"></b-input>
        <span class="text-danger" v-if="!returnAccount.bank.validate && returnAccount.bank.validate!=undefined">{{returnAccount.bank.warning}}</span>
      </b-form-group>
      <b-form-group>
        <h6 class="font-size-md"><span class="ml-n1 text-danger">*</span>{{$t('order.return.account.accountbranchbank')}}</h6>
        <b-input class="bg-white" :placeholder="$t('order.branchbankplaceholder')" v-model="returnAccount.branchBank.value" :formatter="inputFormatter"></b-input>
        <span class="text-danger" v-if="!returnAccount.branchBank.validate && returnAccount.branchBank.validate!=undefined">{{returnAccount.branchBank.warning}}</span>
      </b-form-group>
      <b-form-group>
        <h6 class="font-size-md"><span class="ml-n1 text-danger">*</span>{{$t('order.return.account.account')}}</h6>
        <b-input class="bg-white" :placeholder="$t('order.accountplaceholder')" v-model="returnAccount.account.value" :formatter="inputFormatter"></b-input>
        <span class="text-danger" v-if="!returnAccount.account.validate && returnAccount.account.validate!=undefined">{{returnAccount.account.warning}}</span>
      </b-form-group>
      </div>
      <!-- 退款帳戶 end -->
      <b-button variant="primary" @mousedown="confirmReturn" class="bg-customize border-customize py-2" block>{{$t('order.return.confirm')}}</b-button>
    </div>
    <!--以下是取消頁面-->
    <div v-if="pageType==='cancel'">
      <div class="mb-5">
      <h5>{{$t('order.cancel.cancelGoods')}}</h5>
      <OrderDetail class="mx-3" :order="order" :isReturnRequestPage="true">
        <template slot="itemAccount">
          <div></div>
        </template>
      </OrderDetail>
      </div>
      <div class="mb-5">
      <h5 class="mb-3">{{$t('order.cancel.reasons')}}</h5>
      <b-form-group>
        <h6 class="font-size-md"><span class="ml-n1 text-danger">*</span>{{$t('order.reason')}}</h6>
        <b-select v-model="selected" :options="cancelOptions" :state="validateState" class="bg-white"></b-select>
      </b-form-group>
      <b-form-group>
        <b-textarea class="bg-white"
         :placeholder="$t('order.cancel.reasonsPlaceholder')"
         :maxlength="limit"
         :state="validateTextArea"
         v-model="reasons"></b-textarea>
        <div id="input-live-feedback" class="invalid-feedback d-flex justify-content-between">
          <span>{{!this.validateTextArea&&this.validateTextArea!=undefined?$t('order.cancel.textareaWording'):''}}</span>
          <small class="text-gray600">
            <span>{{ reasons.length }}</span>/{{ limit }}
          </small>
        </div>
      </b-form-group>
      </div>
      <!-- 取消帳戶 begin -->
      <!--// TODO:未來增加ATM匯款，需要判斷已付款情形下，要顯示此帳戶-->
      <!-- <div class="mb-5" v-if="this.order.paymentType.includes('COD')&&this.order.paymentType">
      <h5 class="mb-3">{{$t('order.return.returnaccount')}}</h5>
      <b-form-group>
        <h6 class="font-size-md"><span class="ml-n1 text-danger">*</span>{{$t('order.return.account.accountname')}}</h6>
        <b-input class="bg-white" placeholder="請輸入戶名" v-model="returnAccount.accountName.value"></b-input>
        <span class="text-danger" v-if="!returnAccount.accountName.validate && returnAccount.accountName.validate!=undefined">{{returnAccount.accountName.warning}}</span>
      </b-form-group>
      <b-form-group>
        <h6 class="font-size-md"><span class="ml-n1 text-danger">*</span>{{$t('order.return.account.accountbank')}}</h6>
        <b-input class="bg-white" placeholder="銀行代碼及名稱，例：822 中國信託" v-model="returnAccount.bank.value"></b-input>
        <span class="text-danger" v-if="!returnAccount.bank.validate && returnAccount.bank.validate!=undefined">{{returnAccount.bank.warning}}</span>
      </b-form-group>
      <b-form-group>
        <h6 class="font-size-md"><span class="ml-n1 text-danger">*</span>{{$t('order.return.account.account')}}</h6>
        <b-input class="bg-white" placeholder="8~16碼數字" v-model="returnAccount.account.value"></b-input>
        <span class="text-danger" v-if="!returnAccount.account.validate && returnAccount.account.validate!=undefined">{{returnAccount.account.warning}}</span>
      </b-form-group>
      </div> -->
      <!-- 取消帳戶 end -->
      <b-button variant="primary" @mousedown="confirmCancel" class="bg-customize border-customize py-2" :disabled="buttonDisabled" block>{{$t('order.cancel.confirm')}}</b-button>
    </div>
  </div>
</template>

<script>
import {
  tap, catchError, filter, map, switchMap,
} from 'rxjs/operators';
import { of } from 'rxjs';
import { mapMutations, mapState } from 'vuex';
import OrderDetail from '@/components/order/OrderDetail.vue';
import Mobile from '@/components/return/Mobile.vue';
import pageSettingGetter from '@/utils/pageSettingGetter';
import dateTimeFormatter from '@/utils/dateTimeFormatter';
import sctService from '@/services/sctService';
import ssoService from '@/services/ssoService';
import Address from '@/components/models/Address.vue';

export default {
  components: {
    OrderDetail,
    Mobile,
    Address,
  },
  props: {
    // 訂單資訊
    order: {
      type: Object,
    },
    // 取消或是退款
    pageType: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      // 選擇退貨種類
      selected: null,
      // 退貨種類
      retunrOptions: [
        { value: null, text: this.$t('order.return.selectType'), disabled: true },
        { value: this.$t('order.return.returnTypeA'), text: this.$t('order.return.returnTypeA') },
        { value: this.$t('order.return.returnTypeB'), text: this.$t('order.return.returnTypeB') },
        { value: this.$t('order.return.returnTypeC'), text: this.$t('order.return.returnTypeC') },
        { value: this.$t('order.return.returnTypeD'), text: this.$t('order.return.returnTypeD') },
        { value: this.$t('order.return.returnTypeE'), text: this.$t('order.return.returnTypeE') },
        { value: this.$t('order.return.returnTypeF'), text: this.$t('order.return.returnTypeF') },
        { value: this.$t('order.return.returnTypeG'), text: this.$t('order.return.returnTypeG') },
        { value: this.$t('order.return.returnTypeH'), text: this.$t('order.return.returnTypeH') },
        { value: this.$t('order.return.returnTypeI'), text: this.$t('order.return.returnTypeI') },
        { value: this.$t('order.return.returnTypeJ'), text: this.$t('order.return.returnTypeJ') },
      ],
      // 取消種類
      cancelOptions: [
        { value: null, text: this.$t('order.return.selectType'), disabled: true },
        { value: this.$t('order.cancel.cancelTypeA'), text: this.$t('order.cancel.cancelTypeA') },
        { value: this.$t('order.cancel.cancelTypeB'), text: this.$t('order.cancel.cancelTypeB') },
        { value: this.$t('order.cancel.cancelTypeC'), text: this.$t('order.cancel.cancelTypeC') },
        { value: this.$t('order.cancel.cancelTypeD'), text: this.$t('order.cancel.cancelTypeD') },
        { value: this.$t('order.cancel.cancelTypeE'), text: this.$t('order.cancel.cancelTypeE') },
        { value: this.$t('order.cancel.cancelTypeF'), text: this.$t('order.cancel.cancelTypeF') },
        { value: this.$t('order.cancel.cancelTypeG'), text: this.$t('order.cancel.cancelTypeG') },
        { value: this.$t('order.cancel.cancelTypeH'), text: this.$t('order.cancel.cancelTypeH') },
        { value: this.$t('order.cancel.cancelTypeI'), text: this.$t('order.cancel.cancelTypeI') },
        { value: this.$t('order.cancel.cancelTypeJ'), text: this.$t('order.return.returnTypeJ') },
      ],
      // 退貨原因
      reasons: '',
      // 退貨原因字數限制
      limit: 450,
      // 退貨人手機
      mobileData: {
        callingCode: '',
        mobile: '',
      },
      // 退貨人姓名
      returnName: '',
      // 退貨人姓名檢查
      returnNameCheck: {
        validate: true, warning: this.$t('order.namecheckwarning'),
      },
      // 退貨條款popup-退貨條款文案
      popupTerms: '',
      // 退貨條款popup-退貨條款標題
      popupTitle: '',
      // 退貨條款popup-同意按鈕
      popupAgreeButton: '',
      // 退貨條款popup-不同意按鈕
      popupDisagreeButton: '',
      // 驗證退貨種類
      validateState: undefined,
      // 退貨人手機驗證
      mobileValidateState: false,
      // 驗證輸入框
      validateTextArea: undefined,
      // 退款帳戶資訊
      returnAccount: {
        accountName: { value: '', validate: undefined, warning: this.$t('order.return.account.accountnamewarning') },
        bank: { value: '', validate: undefined, warning: this.$t('order.return.account.bankwarning') },
        branchBank: { value: '', validate: undefined, warning: this.$t('order.return.account.branchbankwarning') },
        account: { value: '', validate: undefined, warning: this.$t('order.return.account.accountwarning') },
      },
      // 退款地址資訊
      returnAddress: {
        country: '', province: '', city: '', district: '', address: '', zipCode: '',
      },
      // 退貨資訊有誤的popup
      warningPop: {
        // 未選擇退貨原因
        selectedWarning: '',
        // 未填寫退貨原因
        checkTextAreaWarning: '',
        // 未填寫退件資訊
        returnInfoWarning: '',
        // 未填寫退款帳戶
        returnAccountWarning: '',
      },
      // 退貨天數限制
      returnDays: 7,
      alertSuccess: {
        title: '',
        context: '',
        variant: 'success',
        dismissSec: 6,
      },
      alertError: {
        title: '',
        context: '',
        variant: 'danger',
        dismissSec: 6,
      },
      // 針對地址輸入欄位的驗證結果
      validateAddressState: undefined,
      validateAddressStatewarning: this.$t('global.please-enter'),
      buttonDisabled: false,
    };
  },
  created() {
    const vm = this;
    // 取得訂單的地址
    if (this.order) {
      this.setMemberSourceData({ id: 'updateAddress', value: true });
      if (!this.order.logisticsProviderId.includes('_ConvenienceStore') && !this.order.logisticsProviderId.includes('PhysicalStore')) {
        this.returnAddress.city = this.order.city;
        this.returnAddress.address = this.order.address;
        this.returnAddress.district = this.order.district;
        this.returnAddress.country = this.order.country ? this.order.country : 'TW';
        this.returnAddress.zipCode = this.order.zipCode;
        this.returnAddress.province = this.order.province;
      }
      this.returnName = this.order.memberName;
      const phonesplit = this.order.memberMobile.split('-');
      // eslint-disable-next-line prefer-destructuring
      this.mobileData.callingCode = phonesplit[0];
      // eslint-disable-next-line prefer-destructuring
      this.mobileData.mobile = phonesplit[1];
      this.returnAccount.accountName.value = this.order.memberName;
    }

    // 取得退貨天數限制
    vm.$store.dispatch('getElectronicCommerce').then((res) => {
      vm.returnDays = res.returnDays;
    });

    // 取得頁面設定
    vm.$store.dispatch('getPageSetting', 'ShoppingHistory')
      .then((setting) => {
        this.popupTerms = pageSettingGetter.getFunctionWording(setting, 'ReturnRequestPopupTerms').replace('{0}', vm.returnDays);
        this.popupTitle = pageSettingGetter.getFunctionWording(setting, 'ReturnRequestPopupTitle');
        this.popupAgreeButton = pageSettingGetter.getFunctionWording(setting, 'ReturnRequestPopupAgreeButton');
        this.popupDisagreeButton = pageSettingGetter.getFunctionWording(setting, 'ReturnRequestPopupDisagreeButton');
      });
  },
  computed: {
    ...mapState([
      'memberDataWithoutPromise',
    ]),
  },
  inject: ['openPopUp', 'openAlert', 'updateOrderButton'],
  methods: {
    ...mapMutations('memberSource', ['setMemberSourceData']),
    // 更新手機或是地址資訊
    updateData(type, data) {
      switch (type) {
        case 'mobile':
          this.updateMobile(data);
          break;
        case 'address':
          this.updateAddress(data);
          break;
        default:
          break;
      }
    },
    // 輸入框去除空白
    inputFormatter(value) {
      value = value.replace(/\s*/g, '');
      return value;
    },
    // 針對退款地址輸入欄位的驗證
    validateAddress() {
      if (!this.returnAddress.address) {
        this.validateAddressState = false;
        this.validateAddressStatewarning = this.$t('global.please-enter');
        return false;
      }

      if (this.returnAddress.address.length < 4) {
        this.validateAddressState = false;
        this.validateAddressStatewarning = this.$t('order.return.addresswarning');
        return false;
      }
      this.validateAddressState = true;
      return true;
    },
    // 再次驗證手機
    validateAgain() {
      this.$nextTick(() => {
        if (!this.$refs.mobile.validateState) {
          switch (this.$refs.mobile.errorMessage) {
            case this.$t('personal-info.please-enter-mobile-Info'):
              this.$refs.mobile.setErrorMessageFromOutside({
                errorMessage: this.$t('personal-info.please-enter-mobile-Info'),
                validateState: false,
              });
              this.mobileValidateState = false;
              return false;
            default:
              this.$refs.mobile.setErrorMessageFromOutside({
                errorMessage: this.$t('personal-info.wrong-mobile'),
                validateState: false,
              });
              this.mobileValidateState = false;
              return false;
          }
        } else {
          this.warningPop.returnInfoWarning = '';
          this.mobileValidateState = true;
          return true;
        }
      });
    },
    // 驗證輸入框
    checkTextArea() {
      if (this.selected === this.$t('order.cancel.cancelTypeJ')) {
        if (this.reasons.length <= 0) {
          this.warningPop.checkTextAreaWarning = this.$t('order.return.returnWarning.checkTextAreaWarning');
          this.validateTextArea = false;
        } else {
          this.warningPop.checkTextAreaWarning = '';
          this.validateTextArea = true;
        }
      } else {
        this.warningPop.checkTextAreaWarning = '';
        this.validateTextArea = true;
      }
    },
    // 驗證退款帳戶
    checkReturnAccount() {
      if (this.order.paymentType.includes('COD') && this.order.paymentType) {
        this.returnAccount.accountName.validate = this.checkReturnAccountName(this.returnAccount.accountName.value);
        this.returnAccount.bank.validate = this.checkReturnAccountBank(this.returnAccount.bank.value);
        this.returnAccount.branchBank.validate = this.checkReturnAccountBank(this.returnAccount.branchBank.value);
        this.returnAccount.account.validate = this.checkAccount(this.returnAccount.account.value);

        if (!this.returnAccount.accountName.validate
        || !this.returnAccount.bank.validate
        || !this.returnAccount.account.validate
        || !this.returnAccount.branchBank.validate) {
          this.warningPop.returnAccountWarning = this.$t('order.return.returnWarning.returnAccountWarning');
          return false;
        }
      }

      this.warningPop.returnAccountWarning = '';
      return true;
    },
    // 驗證戶名
    checkReturnAccountName(value) {
      if (!value || value.length < 2) {
        return false;
      }
      return true;
    },
    // 驗證銀行
    checkReturnAccountBank(value) {
      if (!value || value.length < 5 || value.length > 50) {
        return false;
      }

      const numberbank = value.slice(0, 3);
      const numberregex = /^[0-9\s]*$/;

      if (!numberregex.test(numberbank)) {
        return false;
      }

      return true;
    },
    // 驗證帳號
    checkAccount(value) {
      const regex = /^[0-9\s]*$/;
      if (!value
      || !regex.test(value)
      || value.length > 16
      || value.length < 8) {
        return false;
      }
      return true;
    },
    // 驗證退件人姓名
    checkReturnName() {
      const vm = this;
      // eslint-disable-next-line func-names
      const checkChinese = function() {
        const regx = /[\u4e00-\u9fa5]/g;
        if (regx.test(vm.returnName)) {
          if (vm.returnName.length >= 2 && vm.returnName.length <= 5) {
            vm.returnNameCheck.validate = true;
            return true;
          }
          vm.returnNameCheck.validate = false;
          return false;
        }
        vm.returnNameCheck.validate = false;
        return false;
      };
      // eslint-disable-next-line func-names
      const checkEnglish = function() {
        const regx = /[a-zA-Z]/g;
        if (regx.test(vm.returnName)) {
          if (vm.returnName.length > 0 && vm.returnName.length <= 10) {
            vm.returnNameCheck.validate = true;
            return true;
          }
          vm.returnNameCheck.validate = false;
          return false;
        }
        vm.returnNameCheck.validate = false;
        return false;
      };

      if (checkChinese() || checkEnglish()) {
        return true;
      }
      return false;
    },
    // 驗證退款地址
    checkReturnAddress() {
      const result = this.$refs.Address.validate();
      return result;
    },
    // 驗證退件資訊
    checkReturnInfo() {
      const checkName = this.checkReturnName();
      this.mobileValidateState = this.$refs.mobile.validate();
      const checkAddress = this.checkReturnAddress() && this.validateAddress();

      if (!checkName || !this.mobileValidateState || !checkAddress) {
        this.warningPop.returnInfoWarning = this.$t('order.return.returnWarning.returnInfoWarning');
        return false;
      }
      this.warningPop.returnInfoWarning = '';
      return true;
    },
    // 更新手機
    updateMobile(data) {
      this.mobileData = data.value;
    },
    // 更新地址
    updateAddress(data) {
      const vm = this;
      vm.returnAddress = data.value;
    },
    // 按下申請退貨
    confirmReturn() {
      const vm = this;
      const checkAccount = vm.checkReturnAccount();
      const checkReturnInfo = vm.checkReturnInfo();

      if (!vm.selected) {
        vm.warningPop.checkTextAreaWarning = vm.$t('order.return.returnWarning.selectedWarning');
        vm.validateState = false;
      } else {
        vm.warningPop.checkTextAreaWarning = '';
        vm.validateState = true;
        vm.checkTextArea();
      }

      if (vm.mobileValidateState && vm.validateState && vm.validateTextArea && checkAccount && checkReturnInfo) {
        vm.openPopUp({
          isOpen: true,
          title: vm.popupTitle,
          content: vm.popupTerms,
          mode: 'default',
          confirmWording: vm.popupAgreeButton,
          cancelWording: vm.popupDisagreeButton,
          isCustomize: true,
          confirm() {
            vm.createReturnRequest();
          },
        });
      } else {
        let content = '';
        Object.keys(vm.warningPop).forEach((key) => {
          content = `${content + vm.warningPop[key]}<br>`;
        });
        vm.openPopUp({
          isOpen: true,
          title: vm.$t('order.return.confirmTitle'),
          content,
          mode: 'hintwithclose',
          confirm() { },
        });
      }
    },
    // 新建退貨申請
    createReturnRequest() {
      const vm = this;
      const shippingReceivedEvent = vm.order.events.find((x) => x.category === 'Delivery' && x.status === 'received');
      const dateTimeString = dateTimeFormatter.formatTaiwanDateTime(new Date(shippingReceivedEvent.time));

      if (Date.now() < new Date(dateTimeString.substring(0, 10)).getTime() + (vm.returnDays + 1) * 24 * 60 * 60 * 1000) {
        const body = {
          orderId: vm.order.id,
          reasonCategory: vm.selected,
          reasonDesc: vm.reasons,
          contactMobile: `0${vm.mobileData.mobile}`,
          category: vm.pageType === 'return' ? 2 : 1,
          name: vm.returnName,
          zipCode: parseInt(vm.returnAddress.zipCode, 10),
          address: vm.returnAddress.city + vm.returnAddress.district + vm.returnAddress.address,
          beneficiaryAccountName: vm.returnAccount.accountName.value,
          beneficiaryBankName: vm.returnAccount.bank.value,
          beneficiaryBankBranchName: vm.returnAccount.branchBank.value,
          beneficiaryAccountNo: vm.returnAccount.account.value,
        };
        const headers = { accessToken: vm.$store.state.accessToken };

        vm.$loading(sctService.createReturnRequest(body, headers).pipe(
          filter((res) => res.response.status === '200'),
          map((res) => res.response.data[0]),
          tap(() => {
            vm.alertSuccess.context = vm.$t('order.return.pass');
            vm.openAlert(vm.alertSuccess);
            vm.updateOrderButton({
              orderId: vm.order.orderId,
              buttonType: 'orderReturn',
              buttonInfo: { disabled: true, text: vm.$t('order.return.requested') },
            });
            vm.$emit('close');
          }),
          catchError((err) => {
            if (err.data.status === '610') {
              // 退貨申請成立失敗
              vm.openPopUp({
                isOpen: true,
                content: vm.$t('order.return.failed-and-contact-customer-service'),
                mode: 'hint',
                confirm() { },
              });
            } else {
              // 退貨申請成立失敗
              vm.openPopUp({
                isOpen: true,
                content: vm.$t('order.return.failed-and-contact-customer-service') + err.data.status,
                mode: 'hint',
                confirm() { },
              });
            }

            return of(0);
          }),
        ));
      } else {
        vm.alertError.context = vm.$t('order.return.notApply');
        vm.openAlert(vm.alertError);
        vm.updateOrderButton({
          orderId: vm.order.orderId,
          buttonType: 'orderReturn',
          buttonInfo: { disabled: true, text: vm.$t('order.return.reject') },
        });
        vm.$emit('close');
      }
    },
    // 按下申請取消
    confirmCancel() {
      const vm = this;
      if (!vm.selected) {
        vm.warningPop.checkTextAreaWarning = vm.$t('order.cancel.cancelWarning.selectedWarning');
        vm.validateState = false;
      } else {
        vm.warningPop.checkTextAreaWarning = '';
        vm.validateState = true;
        vm.checkTextArea();
      }

      if (vm.validateState && vm.validateTextArea) {
        vm.openPopUp({
          isOpen: true,
          title: vm.$t('order.cancel.popupwording.title'),
          content: vm.$t('order.cancel.popupwording.content'),
          mode: 'default',
          confirmWording: vm.popupAgreeButton,
          cancelWording: vm.popupDisagreeButton,
          isCustomize: true,
          confirm() {
            vm.createCancelRequest();
          },
        });
      } else {
        let content = '';
        Object.keys(vm.warningPop).forEach((key) => {
          content = `${content + vm.warningPop[key]}<br>`;
        });
        vm.openPopUp({
          isOpen: true,
          title: vm.$t('order.cancel.confirmTitle'),
          content,
          mode: 'hintwithclose',
          confirm() { },
        });
      }
    },
    // 新建取消申請
    createCancelRequest() {
      const vm = this;
      const body = {
        companyID: vm.$store.state.companyId,
        memberSourceId: vm.$store.state.memberSourceId,
        eRPOrderID: vm.order.eRPOrderID,
      };

      vm.$loading(ssoService.getDigest(body.companyID, body.memberSourceId, body).pipe(
        filter((res) => res.response.status === '200'),
        map((res) => res.response.data[0]),
        catchError(() => {
          vm.openPopUp({
            isOpen: true,
            content: vm.$t('order.cancel.failed-and-contact-customer-service'),
            mode: 'hint',
            confirm() { },
          });

          return of(0);
        }),
        switchMap((res) => {
          const headers = {
            accessToken: vm.$store.state.accessToken,
            digest: res.digest,
          };
          const body2 = {
            companyID: vm.$store.state.companyId,
            memberSourceId: vm.$store.state.memberSourceId,
            eRPOrderID: vm.order.eRPOrderID,
          };
          return sctService.getOrderwithERPOrderID(body2, headers);
        }),
        catchError(() => {
          vm.openPopUp({
            isOpen: true,
            content: vm.$t('order.cancel.failed-and-contact-customer-service'),
            mode: 'hint',
            confirm() { },
          });

          return of(0);
        }),
        filter((res) => res.response.status === '200'),
        map((res) => res.response.data[0]),
        switchMap((res) => {
          const { deliveryStatus } = res;
          const { status } = res;

          if (status === 'cancel') {
            vm.alertSuccess.context = vm.$t('order.cancel.submit');
            vm.openAlert(vm.alertSuccess);
            vm.updateOrderButton({
              orderId: vm.order.orderId,
              buttonType: 'orderCancel',
              buttonInfo: { disabled: true, text: vm.$t('order.cancel.pass') },
            });
            vm.$emit('close');

            return of(0);
          }

          if (status === 'processing' && (deliveryStatus === 'undelivered' || deliveryStatus === 'uncollected' || deliveryStatus === 'processing')) {
            const createcancelrequestbody = {
              orderId: vm.order.id,
              reasonCategory: vm.selected,
              reasonDesc: vm.reasons,
              contactMobile: '',
              category: vm.pageType === 'return' ? 2 : 1,
              name: '',
              zipCode: null,
              address: '',
              beneficiaryAccountName: '',
              beneficiaryBankName: '',
              beneficiaryAccountNo: '',
            };
            const createcancelrequestheaders = { accessToken: vm.$store.state.accessToken };
            return sctService.createReturnRequest(createcancelrequestbody, createcancelrequestheaders);
          }

          vm.alertError.context = vm.$t('order.cancel.notApply');
          vm.openAlert(vm.alertError);
          vm.updateOrderButton({
            orderId: vm.order.orderId,
            buttonType: 'orderCancel',
            buttonInfo: { disabled: true, text: vm.$t('order.cancel.reject') },
          });
          vm.$emit('close');

          return of(0);
        }),
        filter((res) => res !== 0),
        filter((res) => res.response.status === '200'),
        tap(() => {
          vm.alertSuccess.context = vm.$t('order.cancel.submit');
          vm.openAlert(vm.alertSuccess);
          vm.updateOrderButton({
            orderId: vm.order.orderId,
            buttonType: 'orderCancel',
            buttonInfo: { disabled: true, text: vm.$t('order.cancel.pass') },
          });
          vm.$emit('close');
        }),
        catchError((err) => {
          switch (err.data.status) {
            // 已有相同類型的退貨申請
            case '609':
              vm.alertSuccess.context = vm.$t('order.cancel.submit');
              vm.openAlert(vm.alertSuccess);
              vm.updateOrderButton({
                orderId: vm.order.orderId,
                buttonType: 'orderCancel',
                buttonInfo: { disabled: true, text: vm.$t('order.cancel.pass') },
              });
              vm.$emit('close');
              break;
            // 其他錯誤
            default:
              vm.alertError.context = vm.$t('order.cancel.failed-and-contact-customer-service');
              vm.openAlert(vm.alertError);
              break;
          }

          return of(0);
        }),
      ));
    },
  },
  watch: {
    selected() {
      if (!this.selected) {
        this.validateState = false;
      } else {
        this.validateState = true;
      }
    },
  },
};
</script>
